<script setup>
  import { computed } from 'vue';
  import IconPinSolid from "@/components/icons/IconPinSolid.vue";
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    type: {
      type: String,
      default: 'button'
    },
    pinned: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    accessibleLabel: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    warningIcon: {
      type: String,
      required: false
    }
  });

  const classObject = computed(() => ({
    'jwx-map-button--pinned': props.pinned,
    'jwx-map-button': true
  }));

</script>

<template>
  <button 
    :type="props.type"
    :class="classObject"
    :disabled="props.disabled"
  >
    <slot></slot>
    <Icon name="pin-solid" v-if="props.pinned" class="jwx-map-button__pin" />
    <Icon name="lock-solid" v-if="props.locked" class="jwx-map-button__locked" />
    <span v-if="props.accessibleLabel" class="jwx-map-button__accessible-label">{{ accessibleLabel }}</span>
  </button>
</template>